import { ChangeEvent } from "react";
import {
  RequiredManager,
  ValidationMessage
} from "../../../shared/RequieredManager";
import { CriterionModel } from "../../providers/CriteriaContext";
import Input from "../form/Input";

type InputWithValidationProps = {
  inputResetKey: number;
  type: "text" | "number";
  item: CriterionModel;
  filterKey: string;
  callback: (e: ChangeEvent<HTMLInputElement>) => void;
  requiredManager: RequiredManager;
  boxLeft?: boolean;
  withBox?: boolean;
  boxText?: string;
  defaultValue?: any;
};

export const InputWithValidation = ({
  inputResetKey,
  type,
  item,
  filterKey,
  callback,
  requiredManager,
  boxLeft = false,
  withBox = false,
  boxText = "",
  defaultValue
}: InputWithValidationProps) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Input
        key={inputResetKey}
        className="form-group"
        type={type}
        item={item}
        filterKey={filterKey}
        callback={requiredManager.makeRequiredWithId(callback, "textId")}
        boxLeft={boxLeft}
        withBox={withBox}
        boxText={boxText}
        defaultValue={defaultValue}
      />
      <ValidationMessage
        defaultValue={item.Value}
        onChange={requiredManager.getValidation("textId")}
      />
    </div>
  );
};
